import {useEffect} from 'react'
import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'
import {ROLE_STORE_MANAGER} from 'shared/constant/lookup/role'

const usePutSelfPassword = (onSuccess) => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()

	const request = (newPassword) => {
		const rolePath = getApiRolePath(userRole)
		const path = userRole === ROLE_STORE_MANAGER ? 'store' : 'franchise'
		fetchRequest('PUT', `/${rolePath}/${path}/my`, {
			password: newPassword,
		})
	}

	useEffect(() => {
		if (!fetchResult) return

		switch (fetchResult?.statusCode) {
			case 200:
				setAlert('비밀번호가 성공적으로 변경되었습니다.')
				if (onSuccess) {
					onSuccess()
				}
				break
			case 400:
				setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			default:
				setAlert('알 수 없는 오류가 발생했습니다.')
				break
		}
	}, [fetchResult])

	return [request, isLoading]
}

export default usePutSelfPassword
